<template>
  <div v-if="load">
    <scale-loader/>
  </div>

  <tabs v-else-if="project_info !== {}" parent="project" >
    <tab id="info" :name="translate('project.section.info')" :href="url+'/info'" >
      <Info
        :id="cur_id"
        :project="project_info"
        @update="get_project"
      />
    </tab>

    <tab id="settings" :name="translate('project.section.settings')" :href="url+'/settings'">
      <Settings
        :id="cur_id"
        :project="project_info"
      />
    </tab>
  </tabs>

  <div v-else>
    <div class="wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">
              Project: {{cur_id}} not found
            </h2>
            <router-link :to="{path:'/project_list'}">
              To List Project
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Info from './Tabs/Info.vue'
import Settings from "./Tabs/Settings.vue";

export default {
  name: 'Project',
  components: {
    Info,
    Settings,
    Tab,
    Tabs,
  },
  data () {
    return {
      section: 'profile',
      project_info: {},
    }
  },

  computed: {
    url () { return '/project/' + this.$route.params.project_id },
    cur_id () { return this.$route.params.project_id },
    load () { return !this.project_info?.id }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'project_section') {
        this.get_project()
      }
    }
  },

  activated(){
    this.get_project()
  },

  methods: {
    get_project () {
      this.$http.v1.getProjectInfo(this.$route.params.project_id, (response) => {
        this.project_info = response.data.project
      })
    }
  }
}

</script>
